import { ThemeProvider } from '@material-ui/core'
import { ConfirmProvider } from 'material-ui-confirm'
import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { Route, HashRouter as Router, Switch } from 'react-router-dom'

import Header from './components/Header'
import TitleBar from './components/TitleBar'
import { AuthContext } from './context/auth'
import Location from './helpers/Locations'
import NotFound from './pages/404'
import Login from './pages/Login'
import theme from './theme'

function App({ t }) {
  const [authTokens, setAuthTokens] = useState(false)

  return (
    <ThemeProvider theme={theme}>
      <ConfirmProvider>
        <AuthContext.Provider value={{ authTokens, setAuthTokens }}>
          <Router>
            <Header />
            <TitleBar title={t('appl.title')} subTitle={<Location />} />
            <Switch>
              <Route exact path="/" component={Login} />
              <Route path="*" component={NotFound} />
            </Switch>
          </Router>
        </AuthContext.Provider>
      </ConfirmProvider>
    </ThemeProvider>
  )
}
export default withTranslation()(App)
